import React from "react";

const Social = () => {
    return (
        <div className="about__social">
            <a href="https://scholar.google.com/citations?user=Y7gW52cAAAAJ" 
            className="about__social-icon" rel="noreferrer" target="_blank">
            <i class="ai ai-google-scholar"></i>
            </a>
            <a href="https://github.com/julia-fu0528" 
            className="about__social-icon" rel="noreferrer" target="_blank">
            <i class="uil uil-github"></i>
            </a>
            <a href="https://www.linkedin.com/in/wanjiafu/" 
            className="about__social-icon" rel="noreferrer" target="_blank">
            <i class="uil uil-linkedin"></i>
            </a>
            
        </div>
    );
   }

   export default Social;